import { createContext, useCallback, useContext, useMemo, useState, type PropsWithChildren } from 'react'
import { AnimatePresence, motion } from 'motion/react'
import { CheckCircle2, Info, X, XCircle } from 'lucide-react'

type Tone = 'success' | 'error' | 'info'
type ToastItem = { id: number; text: string; tone: Tone }
type Ctx = { push: (text: string, tone?: Tone) => void }
const ToastContext = createContext<Ctx>({ push: () => {} })

export function ToastProvider({ children }: PropsWithChildren) {
  const [items, setItems] = useState<ToastItem[]>([])
  const push = useCallback((text: string, tone: Tone = 'success') => {
    const id = Date.now() + Math.random()
    setItems(v => [...v, { id, text, tone }])
    window.setTimeout(() => setItems(v => v.filter(x => x.id !== id)), 3400)
  }, [])
  const value = useMemo(() => ({ push }), [push])
  return <ToastContext.Provider value={value}>{children}<div className="toast-stack"><AnimatePresence>{items.map(item => {
    const Icon = item.tone === 'success' ? CheckCircle2 : item.tone === 'error' ? XCircle : Info
    return <motion.div className={`toast toast-${item.tone}`} key={item.id} initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 25 }}><Icon size={18}/><span>{item.text}</span><button onClick={() => setItems(v => v.filter(x => x.id !== item.id))}><X size={14}/></button></motion.div>
  })}</AnimatePresence></div></ToastContext.Provider>
}

export const useToast = () => useContext(ToastContext)
